import TablePagination from '@mui/material/TablePagination'
import useLayout from '@/features/layout/useLayout';
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import Pagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

const TablePageSelector = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange
}) => {
  const { isMobile } = useLayout();
  const lastPage = Math.max(Math.ceil(count / rowsPerPage) - 1, 0)
  
  return (
    isMobile ? (
      <MobilePagination
        count={count}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[ 10, 25 ]}
      />
    ) : (
      <TablePagination
        component="div"
        count={count}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[ 10, 25 ]}
        rowsPerPage={rowsPerPage}
        page={page}
      />
    )
  )
}

const MobilePagination = ({
  count,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  onPageChange,
  onRowsPerPageChange
}) => {
  const theme = useTheme()
  const totalPages = Math.ceil(count / rowsPerPage)
  const currentPage = page + 1

  const handlePaginationChange = (event, newPage) => {
    onPageChange(event, newPage - 1)
  }

  const handleRowsChange = (event) => {
    onRowsPerPageChange(event)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          textAlign: 'center',
          fontSize: '0.875rem'
        }}>
        {page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, count)} of{' '}
        {count} entries
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePaginationChange}
          color="primary"
          size="large"
          renderItem={(item) => (
            <PaginationItem
              slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
              sx={{
                minWidth: 44,
                height: 44,
                fontSize: '1rem',
                '&.Mui-selected': {
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                  '&:hover': { backgroundColor: theme.palette.primary.dark }
                }
              }}
              {...item}
            />
          )}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontSize: '0.875rem'
          }}>
          Show:
        </Typography>
        <FormControl size="small" sx={{ minWidth: 80 }}>
          <Select
            value={rowsPerPage}
            onChange={handleRowsChange}
            sx={{ height: 36, fontSize: '0.875rem' }}
          >
            {rowsPerPageOptions.map((size) => (
              <MenuItem key={size} value={size} sx={{ fontSize: '0.875rem' }}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontSize: '0.875rem'
          }}>
          entries
        </Typography>
      </Box>
    </Box>
  );
}


export default TablePageSelector;